function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// Licensed to Cloudera, Inc. under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  Cloudera, Inc. licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/* eslint-disable */

/**
 * AUTOCOMPLETE_MODULES and SYNTAX_MODULES are generated, do not edit manually, see tools/jison/generateParsers.js
 */
var AUTOCOMPLETE_MODULES = {
  dbsql: function dbsql() {
    return import(
    /* webpackChunkName: "dbsql-parser" */
    "./dbsql/dbsqlAutocompleteParser");
  }
};
var SYNTAX_MODULES = {
  dbsql: function dbsql() {
    return import(
    /* webpackChunkName: "dbsql-parser" */
    "./dbsql/dbsqlSyntaxParser");
  }
};
/* eslint-enable */

export var SqlParserRepository = /*#__PURE__*/function () {
  function SqlParserRepository() {
    _classCallCheck(this, SqlParserRepository);

    this.modulePromises = {};
  }

  _createClass(SqlParserRepository, [{
    key: "getParser",
    value: function () {
      var _getParser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dialect, parserType) {
        var modules, targetModule;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.modulePromises[dialect + parserType]) {
                  modules = parserType === 'Autocomplete' ? AUTOCOMPLETE_MODULES : SYNTAX_MODULES;
                  targetModule = modules[dialect] || modules.dbsql // Should re-introduce generic
                  ;

                  if (!modules[dialect]) {
                    console.warn('Dialect ' + dialect + ' not available, falling back to generic.');
                  }

                  this.modulePromises[dialect + parserType] = new Promise(function (resolve, reject) {
                    targetModule().then(function (module) {
                      return resolve(module["default"]);
                    })["catch"](reject);
                  });
                }

                return _context.abrupt("return", this.modulePromises[dialect + parserType]);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getParser(_x, _x2) {
        return _getParser.apply(this, arguments);
      }

      return getParser;
    }()
  }, {
    key: "getAutocompleteParser",
    value: function () {
      var _getAutocompleteParser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dialect) {
        var autocompleteParser;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getParser(dialect, 'Autocomplete');

              case 2:
                autocompleteParser = _context2.sent;
                return _context2.abrupt("return", autocompleteParser);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getAutocompleteParser(_x3) {
        return _getAutocompleteParser.apply(this, arguments);
      }

      return getAutocompleteParser;
    }()
  }, {
    key: "getSyntaxParser",
    value: function () {
      var _getSyntaxParser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dialect) {
        var syntaxParser;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getParser(dialect, 'Syntax');

              case 2:
                syntaxParser = _context3.sent;
                return _context3.abrupt("return", syntaxParser);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getSyntaxParser(_x4) {
        return _getSyntaxParser.apply(this, arguments);
      }

      return getSyntaxParser;
    }()
  }]);

  return SqlParserRepository;
}();
var sqlParserRepository = new SqlParserRepository();
export default sqlParserRepository;